/**
 * Normalizes WHMCS gator-protect list responses into a plans array.
 * Supports `{ data: [...] }` and direct array payloads.
 */
export const extractGatorProtectPlansList = (response) => {
  const payload = response?.data;

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.data?.data)) {
    return payload.data.data;
  }

  return [];
};
